module.exports = __webpack_public_path__ + "r-v3/img/ml_64_00_over.3e794dbd.jpg";